import React, { ProfilerOnRenderCallback } from 'react';

const isDev =
  typeof process !== 'undefined' &&
  (process.env?.NX_ENV === 'development' || process.env?.NODE_ENV === 'development');

const onRender: ProfilerOnRenderCallback = (
  id,
  phase,
  actualDuration,
  baseDuration,
  startTime,
  commitTime,
) => {
  if (!isDev || typeof console?.log !== 'function') return;
  const label = `[Profiler ${id}] ${phase}`;
  console.log(label, {
    actualDuration: `${actualDuration.toFixed(2)} ms`,
    baseDuration: baseDuration > 0 ? `${baseDuration.toFixed(2)} ms` : 'n/a',
    commitTime: `${(commitTime - startTime).toFixed(2)} ms`,
  });
};

interface AppProfilerProps {
  id: string;
  children: React.ReactNode;
}

export function AppProfiler({ id, children }: AppProfilerProps) {
  if (!isDev) {
    return children;
  }
  return (
    <React.Profiler id={id} onRender={onRender}>
      {children}
    </React.Profiler>
  );
}

